import React, { useEffect } from "react";
import {
  DeleteFlashFavorite,
  UserFlashFavorite,
  getProduct,
  getSubCategory,
} from "../axios";
import { useState } from "react";
import { DownIcon, TimesIcon, TrashIcon } from "../assets/Icons";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const FavoriteFlash = () => {
  const [flashFavoriteList, setFlashFavoriteList] = useState([]);

  // console.log("flashFavoriteList", flashFavoriteList);

  const fetchDataList = () => {
    let phone = localStorage.getItem("phonenumber");
    if (phone) {
      UserFlashFavorite(phone)
        .then((res) => {
          setFlashFavoriteList(res.data);
        })
        .catch((error) => {
          console.log(error.message);
        });
    }
  };

  useEffect(() => {
    fetchDataList();
  }, []);

  const deleteFavoriteFlash = (e, id) => {
    e.stopPropagation();
    let phone = localStorage.getItem("phonenumber");
    DeleteFlashFavorite(phone, id).then((res) => {
      if (res.data === "1") {
        toast.success("با موفقیت حذف شد.");
        fetchDataList();
      } else {
        toast.error("عملیات حذف با خطا مواجه شد");
      }
    });
  };

  const [subCategory, setSubCategory] = useState();
  useEffect(() => {
    getSubCategory(4).then(({ data }) => {
      setSubCategory(data);
    });
  }, []);

  const [productBySubCategory, setProductBySubCategory] = useState([]);
  const [productList, setProductList] = useState([]);
  const [callNewProduct, setCallNewProduct] = useState(0);

  useEffect(() => {
    if (callNewProduct) setProductList([]);

    Promise.all(
      flashFavoriteList.map((item) => getProduct(item.productID))
    ).then((results) => {
      // Use flatMap to flatten the nested arrays of data into one array
      let newArray = results.flatMap(({ data }) => data);
      setProductList(newArray);
    });
  }, [flashFavoriteList, callNewProduct]);

  useEffect(() => {
    let filterProducts = productList.filter(
      (item) => item.subCategoryID == callNewProduct
    );
    const ids = new Set();

    const result = filterProducts.filter((obj) => {
      if (ids.has(obj.id)) {
        return false; // remove object
      }
      ids.add(obj.id);
      return true; // keep object
    });
    // Object.assign([], result).reverse()
    setProductBySubCategory(result);
  }, [productList]);

  // -------------------------------------- Modal Flash Showing Handler
  const [showFlash, setShowFlash] = useState(false);
  const [changeImg, setChangeImg] = useState(0);
  const [modalImage, setModalImage] = useState({
    img: "",
    fileasli: "",
    description: "",
  });
  const modalFlashShowingHandler = (e, item) => {
    e.preventDefault();
    setShowFlash(true);
    setModalImage({
      description: item.description,
      img: item.filedemo,
      fileasli: item.fileasli,
    });
  };

  useEffect(() => {
    productBySubCategory?.filter((item, index) => {
      if (index == changeImg) {
        setModalImage({
          description: item.description,
          img: item.filedemo,
          fileasli: item.fileasli,
        });
      }
    });
  }, [productBySubCategory, changeImg]);

  const [rotateState, setRotateState] = useState({ status: false, value: "" });

  const clickShowBackProduct = (value) => {
    if (value === true) {
      setRotateState({ status: true, value: "flipped" });
    } else {
      setRotateState({ status: false, value: "" });
    }
  };

  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <div style={{ minHeight: "50vh" }} className="container">
      {/* ----------------------- Start Modal Flash Showing Handler ------------------- */}
      {showFlash && (
        <div
          className="modal fade show"
          role="dialog"
          style={{
            display: `${showFlash ? "block" : "hidden"}`,
            backgroundColor: "rgba(0,0,0,0.6)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div
              className="modal-content rounded"
              style={{
                maxHeight: "90vh",
                overflowY: "scroll",
                // overflowX: "hidden",
              }}
            >
              <div className="modal-header">
                <button
                  type="button"
                  className="close m-1 text-center"
                  onClick={() => {
                    setShowFlash(false);
                    setRotateState({ status: false, value: "" });
                    setChangeImg(1);
                  }}
                >
                  <TimesIcon />
                </button>
                <h5 className="modal-title">فلش کارت</h5>
              </div>
              <div className="modal-body mx-auto">
                {/* <p>
                  {changeImg}/{productBySubCategory.length}
                </p> */}
                <div
                  className="border rounded shadow-sm my-8"
                  style={{ height: "450px", width: "350px", objectFit: "fill" }}
                >
                  <img
                    src={`${
                      rotateState.status ? modalImage.fileasli : modalImage.img
                    }`}
                    alt="Product_image"
                  />
                </div>
                <div
                  className="py-8"
                  style={{ width: "350px", marginTop: "60px" }}
                >
                  <button
                    onClick={() => clickShowBackProduct(!rotateState.status)}
                    className="flip btn btn-primary mt-8 w-100"
                  >
                    برگرداندن کارت
                  </button>
                  <div className=" d-flex align-items-center justify-content-between mt-4 mb-2">
                    <button
                      onClick={() => setChangeImg((prevState) => prevState - 1)}
                      disabled={changeImg < 1}
                      className="btn btn-primary "
                    >
                      قبلی
                    </button>
                    <button
                      onClick={() => setChangeImg((prevState) => prevState + 1)}
                      className="btn btn-primary "
                      disabled={changeImg == productBySubCategory.length - 1}
                    >
                      بعدی
                    </button>
                  </div>
                </div>
              </div>
              <p
                style={{ textAlign: "justify", marginBottom: "20px" }}
                className="modal-footer mr-auto"
              >
                <span
                  className="text-primary"
                  style={{ fontSize: "16px", fontWeight: "600" }}
                >
                  توضیحات:
                </span>
                {modalImage.description}
              </p>
            </div>
          </div>
        </div>
      )}
      {/* // -------------------------------------------------------- End Modal Flash Showing Handler ------------------- */}
      {/* -------------------------- فیلتر دسته بندی ----------------- */}
      <div className="form-group row mt-4 " style={{ maxWidth: 400 }}>
        <select
          value={callNewProduct}
          onChange={(e) => {
            setCallNewProduct(e.target.value);
          }}
          className="form-select mx-auto col-11 col-sm-6 col-md-4 text-center"
          id="exampleFormControlSelect1"
        >
          <option value={0}>انتخاب کنید</option>
          {subCategory?.map((item, index) => {
            return (
              <option key={index} value={item.id}>
                {item.subCategoryTitle}
              </option>
            );
          })}
        </select>
      </div>

      {/* --------------------------------------------------------- */}
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {productBySubCategory?.map((item, index) => {
          return (
            <div
              key={index}
              onClick={(e) => {
                modalFlashShowingHandler(e, item);
                setChangeImg(index);
              }}
              className="col-12 col-md-5"
            >
              <div
                className="bg-light px-2 my-2 border rounded d-flex align-items-center justify-content-between"
                style={{ height: "70px", padding: 45 }}
              >
                <img
                  src={item.img}
                  alt="flash_image"
                  className="border p-1 object-fit-contain"
                  style={{ width: "70px", height: "60px" }}
                />
                <div className="mr-auto ml-4">
                  <p>{item.title}</p>
                  <p>{item.subCategoryTitle}</p>
                </div>
                <button
                  onClick={(e) => deleteFavoriteFlash(e, item.id)}
                  className="btn btn-sm btn-danger"
                >
                  <TrashIcon />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FavoriteFlash;
